import { get } from 'lodash';
import { connect } from 'react-redux';
import { MEMBERS_APP_ID } from '../../constants/applications';
import { InternalLink, ExternalLink } from '../../components/link';
import { getApplicationConfig } from '../../selectors/communities-context-selectors';
import { navigateToBlog, navigateToForum, navigateToMembers } from '../../services/navigate-to-section';

export default {
  Link: InternalLink,
  MembersLink: connect(state => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: '/',
  }))(ExternalLink),
  ProfileLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}`,
  }))(ExternalLink),
  FollowingLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}/following`,
  }))(ExternalLink),
  FollowersLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}/followers`,
  }))(ExternalLink),
  SettingsLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}/settings`,
  }))(ExternalLink),
  NotificationsLink: connect(state => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: 'members',
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/notifications`,
  }))(ExternalLink),
  navigateToMembers: () => navigateToMembers('/'),
  navigateToProfile: user => navigateToMembers(`/${get(user, 'slug')}`),
  navigateToProfileSettings: user => navigateToMembers(`/${get(user, 'slug')}/settings`),
  navigateToNotifications: () => navigateToMembers('/notifications'),
  navigateToEditPost: location => navigateToForum(location),
  navigateToCreatePost: () => navigateToBlog('/create-post'),
  navigateToMyDrafts: user => navigateToMembers(`/${user.slug}/blog-drafts`),
};



// WEBPACK FOOTER //
// ./app/services/navigation-provider/forum-with-members-app.js